// extracted by mini-css-extract-plugin
module.exports = {"root":"simpleTable_root__24SQy","table":"simpleTable_table__2dwio"};